// extracted by mini-css-extract-plugin
export default {"button":"Q3AcQ"};